import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import './LicenseErrorPopup.scss';

interface LicenseErrorPopupProps {
  isOpen: boolean;
  onClose: () => void;
  datasetName?: string;
  action?: string;
  reason?: string;
}

const LicenseErrorPopup: React.FC<LicenseErrorPopupProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;
  return (
    <>
      <div className="license-error-backdrop" onClick={onClose} />
      <div className="license-error-popup">
        <div className="license-error-header">
          <h3>Upgrade today</h3>
          <button className="license-error-close" onClick={onClose}>
            ✖
          </button>
        </div>
        
        <div className="license-error-content">
          <div className="license-error-message">
            <p className="license-error-reason">
              This dataset is not currently included in your subscription.
            </p>
            
            <p className="license-error-upgrade">
              Unlock the full potential of bMark, contact <a href = "mailto: sales@belltreegroup.co.uk" style={{color:"rgb(255,0,0)"}}>sales@belltreegroup.co.uk</a> today.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default LicenseErrorPopup; 